
export default {
    data() {
        return {
            loading: true,
            bank: '',
            lmt: '',
            deposit_id: '',
            agent_id: '',
            agent: '',
            currentSort: 'none',
            currentSortOrder: 'asc',
            axios: window.axios

        }
    },
    mounted() {

    Event.$on("reload", () => {
        setTimeout(() => {
            this.loadData()
        }, 1000);
      });
    },
    methods: {
        //retrive the params from the url and store them in variables
        //trigered before loading data from the server
        loadState() {

            for (const [key, value] of Object.entries(this.$router.currentRoute.query)) {
                this[key] = value;
            }

            if (
                this.$route.params.id &&
                this.$route.params.id != ""
            ) {
                this.bank_id = this.$route.params.id;
            }
            if (
                this.$route.params.lmt &&
                this.$route.params.lmt != ""
            ) {
                this.lmt_id = this.$route.params.lmt;
            }
            if (
                this.$route.params.deposit_id &&
                this.$route.params.deposit_id != ""
            ) {
                this.deposit_id = this.$route.params.deposit_id;
            }
            if (
                this.$route.params.agent_id &&
                this.$route.params.agent_id != ""
            ) {
                this.agent_id = this.$route.params.agent_id;
            }
        },


        //make the API request to backend
        // trigered on component create and/or pagination change ,search or filters
        loadData(data = null) {



            this.loading = true;

            this.loadState();

            let url = ''

            let id = this.bank_id ? this.bank_id : '';
            let lmt_id = this.lmt_id ? this.lmt_id : '';

            if (data == null) {

                //add bank and lmt id to the apiurl if they are set 
                if (this.api_url.includes("?")) {
                    url = this.api_url +
                        "&bank_id=" + id
                } else {
                    url = this.api_url +
                        "?bank_id=" + id
                }
                
                

                url = url + "&lmt_id=" + lmt_id + "&deposit_id=" + this.deposit_id + "&agent_id=" + this.agent_id;

                //get all the url parametars from the browser and add them to the API url
                for (const [key, value] of Object.entries(this.$router.currentRoute.query)) {
                    if (value)
                        url = url + "&" + key + "=" + value
                }
            } else {
                url = this.api_url + '?f=1';
                for (const [key, value] of Object.entries(data)) {
                    if (value)
                        url = url + "&" + key + "=" + value
                }

                if (this.deposit_id) {
                    url = url + "&deposit_id=" + this.deposit_id;
                }
                if (this.agent_id) {
                    url = url + "&agent_id=" + this.agent_id;
                }
            }

            let q = {}
            for (const [key, value] of Object.entries(this.$router.currentRoute.query)) {
                q[key] = value;
            }
            q.ready = !q.ready;
            
            if(this.status == 1 && !url.includes("status")) {
                if(url.includes("?")) {
                    url = url + "&status=1";
                } else {
                    url = url + "?status=1";
                }
            }

            //update the url
            this.$router.push({
                path: this.$route.path,
                query: q
            }).catch(() => { });

            // wait for the previous 'for' to finish than get the data from the server 
            setTimeout(() => {
                this.axios
                    .get(url)
                    .then(({ data }) => {
                        if (this.$route.meta.extraLoad) {
                            this.items = data.data.data;
                        } else {
                            this.items = data.data;
                        }
                        this.pagination = data;
                        this.loading = false;
                        if (data.bank) { this.bank = data.bank; }
                        if (data.lmt) { this.lmt = data.lmt; }
                        if (data.agent) { this.agent = data.agent; }
                    })
                    .catch(() => {
                        this.loading = false;
                    });
            }, 200);

            Event.$emit('data_loaded');
        },

        //load data with a search_term
        //trigered when user enters a serach term in input
        search() {

            //save the prev. data from the url
            let q = {}
            for (const [key, value] of Object.entries(this.$router.currentRoute.query)) {
                q[key] = value;
            }

            //reset to first page
            q.page = 1;

            //add the search term
            q.search_term = this.search_term;

            //update the router params
            this.$router.push({
                path: this.$route.path,
                query: q
            }).catch(() => { });

            this.loadData();
        },

        //filter from the dropdown ex:active/inactive
        //data: $event (selected value) , key: type/name of the filter
        filterResults(data, key = "status") {

            //save the prev. data 
            let q = {}
            for (const [key, value] of Object.entries(this.$router.currentRoute.query)) {
                q[key] = value;
            }

            if (key == "date_range") {
                q.start_date = data[0];
                q.end_date = data[1];
            } else {
                //if filter value has been set , add it to the query
                if (data != 'null') { q[key] = data }
            }
            //update the url
            this.$router.push({
                path: this.$route.path,
                query: q
            }).catch(() => { });

            //reload the data
            this.loadData();
        },
        orderBy() {

            //save the prev. data 
            let q = {}
            for (const [key, value] of Object.entries(this.$router.currentRoute.query)) {
                q[key] = value;
            }

            if (this.currentSort != "none") {
                //set the order_by params
                q.order_by = this.currentSort;
                q.asc = this.currentSortOrder == "asc" ? 1 : 0;
            }

            //reset to first page
            q.page = 1;

            //update the url
            this.$router.push({
                path: this.$route.path,
                query: q
            }).catch(() => { });

            //reload the data
            this.loadData();

            return this.items;
        }
    }
}